// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r4-6";
export var imgContainer = "_r4-3";
export var menuIcon = "_r4-5";
export var pillWrapper = "_r4-2";
export var pillsContainer = "_r4-1";
export var subscriptionCard = "_r4-0";
export var subscriptionLogo = "_r4-4";